import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LeftMenu01 from "../../components/layout/leftMenu01.jsx";
import Header from "../../components/layout/header-candidate.jsx";
import Select from "react-select";
import { awsConfig } from "../../config.js";
import { ToastContainer, toast } from "react-toastify";
import { filesize } from "filesize";
import Loading from "../../images/loading.gif";
import AWS from "aws-sdk";
import {
  FaCloudUploadAlt,
  FaFileAlt,
  FaPlusCircle,
  FaTrashAlt,
} from "react-icons/fa";
import ReactDatePicker from "react-datepicker";
import { backendApi } from "../../api/apiService.js";
export default function CandidateResumeUpload() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  let jobData = location.state.position;
  let jobSummary = jobData.summary;
  const [menuClick, setMenuClick] = useState(false);
  const [dob, setDob] = useState(null);
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  const [firstName, setFirstName] = useState("");
  const [address, setAddress] = useState("");
  const [emailId, setEmailId] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [gender, setGender] = useState("");
  const [skillsArray, setSkillsArray] = useState([]);
  const [totalExperience, setTotalExperience] = useState("");
  const [ctc, setCtc] = useState("");
  const [ectc, setEctc] = useState("");
  const [referralId, setReferralId] = useState("");
  const [docLink, setDocLink] = useState("");
  const [skillId, setSkillId] = useState("");
  const [locality, setLocality] = useState("");
  const [docView, setDocView] = useState("");
  const [docName, setDocName] = useState("");
  const [docSize, setDocSize] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [activeNoticePeriod, setActiveNoticePeriod] = useState("");
  const [preferredLocation, setPreferredLocation] = useState("");
  const [willingToRelocate, setWillingToRelocate] = useState("");
  const [jobSkills, setJobSkills] = useState(location.state.jobSkills);
  let s3;
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  const Cancel = () => {
    navigate(-1);
  };

  const deleteFile = () => {
    setDocLink("");
    setAttachmentUrl("");
    setDocName("");
    setDocSize("");
    setDocView(false);
  };

  const handleSkillChange = (e) => {
    setSkillId(e);
  };

  const handleDateChange = (e) => {
    console.log(e);
    setDob(new Date(e));
  };
  const handleFileUpload = async (e) => {
    const allowedFileTypes = [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ];
    const files = e.target.files[0];
    e.target.value = null;
    if (files) {
      // Check if the selected file type is allowed
      if (allowedFileTypes.includes(files.type)) {
        try {
          const bucketParams = {
            Bucket: awsConfigDataState.s3Bucket,
          };
          AWS.config.update({
            accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
            secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
            region: "us-east-1",
          });
          s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            params: bucketParams,
          });
          const data = await s3
            .upload({
              Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${files.name}`,
              Body: files,
              ACL: "public-read",
            })
            .promise();
          setAttachmentUrl(data.Location);
          setDocLink(data.Location);
          setDocView(true);
          setDocName(files.name);
          setDocSize(filesize(files.size, { base: 10 }).toString());
        } catch (e) {
          console.error("error found", e);
        }
      }
    }
  };
  const saveForm = () => {
    if (firstName === "") {
      toast.warn("Name required", { containerId: "D" });
      return false;
    } else if (address === "") {
      toast.warn("Address Required", { containerId: "D" });
      return false;
    } else if (phoneNo === "") {
      toast.warn("Phone No. required", { containerId: "D" });
      return false;
    } else if (gender === "") {
      toast.warn("Gender required", { containerId: "D" });
      return false;
    } else if (dob === null) {
      toast.warn("DOB required", { containerId: "D" });
      return false;
    } else if (emailId === "") {
      toast.warn("Email Id required", { containerId: "D" });
      return false;
    } else if (skillId.length === 0) {
      toast.warn("Skills required", { containerId: "D" });
      return false;
    } else if (totalExperience === "") {
      toast.warn("Total experience required", { containerId: "D" });
      return false;
    } else if (locality === "") {
      toast.warn("Location required", { containerId: "D" });
      return false;
    } else if (willingToRelocate === "") {
      toast.warn("Please choose if Willing to Relocate?", { containerId: "D" });
      return false;
    } else if (activeNoticePeriod === "") {
      toast.warn("Pleas3 select active notice period", { containerId: "D" });
      return false;
    } else if (ctc === "") {
      toast.warn("CTC Required", { containerId: "D" });
      return false;
    } else if (ectc === "") {
      toast.warn("Expected CTC Required", { containerId: "D" });
      return false;
    } else if (attachmentUrl === "") {
      toast.warn("Please upload a resume", { containerId: "D" });
      return false;
    }
    setIsloading(true)
    const req = {
      functionName: "liveApply",
      site_id: jobData.site_id,
      job_opening_id: jobData.id,
      full_name: firstName,
      mobile_no: phoneNo,
      email_id: emailId,
      skill_name: skillId.map((data) => data.label),
      total_experiance: totalExperience,
      location: locality,
      relocate: willingToRelocate,
      notice_period: `${activeNoticePeriod} Month`,
      ctc: ctc,
      ectc: ectc,
      attachmentUrl: attachmentUrl,
      address: address,
      dob: dob,
      gender: gender,
      employee_referal_id: referralId,
    };
    console.log("req", req);
    backendApi(req).then((data) => {
      if (data.success === 1) {
        toast.success("Applied successfully!!", { containerId: "D" });
        setTimeout(() => {
          navigate("/dashboard/candidateDashboard");
        }, 3000);
      }
      console.log(data);
    }).finally(()=>{
      setIsloading(false)
    });
  };
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Resume Upload"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="main-container">
          <ToastContainer
            enableMultiContainer
            containerId={"D"}
            position="bottom-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="row mb-3">
            <div className="col-lg-12 col-md-12">
              <div className="card main-card-box">
                <div className="card-body">
                  {/* <div className="main-head py-2">Scheduled Jobs</div> */}

                  <div className="row">
                    <h4 className="popup_head py-2">Apply for {jobSummary}</h4>
                    <div className="fileUpload">
                      <label className="label " style={{ width: "100%" }}>
                        <div className="upload-files-container">
                          <div className="drag-file-area">
                            <span className="material-icons-outlined upload-icon">
                              <FaCloudUploadAlt />
                            </span>
                            <h3 className="dynamic-message">
                              {" "}
                              Upload your resume here{" "}
                            </h3>
                            <span className="reBrowse">
                              <label className="label">
                                <span className="browse-files">
                                  <input
                                    type="file"
                                    className="default-file-input"
                                    onChange={(e) => {
                                      handleFileUpload(e);
                                      e.target.value = null;
                                    }}
                                  />
                                  <span className="browse-files-text">
                                    {" "}
                                    browse file
                                  </span>{" "}
                                  <span>from device</span>{" "}
                                </span>
                              </label>
                            </span>
                          </div>
                          <span className="cannot-upload-message">
                            {" "}
                            <span className="material-icons-outlined">
                              error
                            </span>{" "}
                            Please select a file first{" "}
                            <span className="material-icons-outlined cancel-alert-button">
                              cancel
                            </span>{" "}
                          </span>

                          {docView && (
                            <div className="file-block">
                              <div className="file-info">
                                {" "}
                                <span className="file-name">
                                  <FaFileAlt /> {docName} |{" "}
                                  <span className="file-size"> {docSize} </span>{" "}
                                </span>
                                <span className="material-icons remove-file-icon">
                                  <FaTrashAlt onClick={() => deleteFile()} />
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                    <div className="resumeForm">
                      <div className="row">
                        <div className="col-md-9 m-auto">
                          <div className="resumeWrap">
                            <div className="row">
                              <div className="col-md-8">
                                <h3 className="dash-sub-head">
                                  Candidate Details
                                </h3>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Full Name
                                    <sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Name"
                                    className="form-control"
                                    value={firstName}
                                    onChange={(e) =>
                                      setFirstName(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Address<sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Address"
                                    className="form-control"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Email Id<sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Email Id"
                                    className="form-control"
                                    value={emailId}
                                    onChange={(e) => setEmailId(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Phone No<sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Phone No"
                                    className="form-control"
                                    value={phoneNo}
                                    onChange={(e) => setPhoneNo(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Gender<sup className="text-danger">*</sup>
                                  </label>
                                  <select
                                    className="form-control"
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                  >
                                    <option value="">-Select-</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label>
                                    Dob<sup>*</sup>
                                  </label>
                                  <ReactDatePicker
                                    className="form-control"
                                    selected={dob}
                                    onChange={(date) => handleDateChange(date)}
                                    showMonthDropdown
                                    showYearDropdown
                                    maxDate={
                                      new Date(
                                        new Date().getFullYear() - 18,
                                        new Date().getMonth(),
                                        new Date().getDate()
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Total Experience
                                    <sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="yrs"
                                    className="form-control"
                                    value={totalExperience}
                                    onChange={(e) =>
                                      setTotalExperience(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    CTC<sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="CTC"
                                    className="form-control"
                                    value={ctc}
                                    onChange={(e) => setCtc(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Expected CTC
                                    <sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="yrs"
                                    className="form-control"
                                    value={ectc}
                                    onChange={(e) => setEctc(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Location<sup className="text-danger">*</sup>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="location"
                                    className="form-control"
                                    value={locality}
                                    onChange={(e) =>
                                      setLocality(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label>
                                    Willing to Relocate?<sup>*</sup>
                                  </label>
                                  <div className="noticePer">
                                    <span
                                      className={`skill-span  me-2 ${
                                        willingToRelocate === "yes" && "active"
                                      }`}
                                      onClick={() =>
                                        setWillingToRelocate("yes")
                                      }
                                    >
                                      Yes
                                    </span>
                                    <span
                                      className={`skill-span  me-2 ${
                                        willingToRelocate === "no" && "active"
                                      }`}
                                      onClick={() => setWillingToRelocate("no")}
                                    >
                                      No
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Notice Period
                                    <sup className="text-danger">*</sup>
                                  </label>
                                  <div className="noticePer">
                                    <span
                                      className={`skill-span me-2 ${
                                        activeNoticePeriod === 1 && "active"
                                      }`}
                                      onClick={() => setActiveNoticePeriod(1)}
                                    >
                                      1 Month
                                    </span>
                                    <span
                                      className={`skill-span  me-2 ${
                                        activeNoticePeriod === 2 && "active"
                                      }`}
                                      onClick={() => setActiveNoticePeriod(2)}
                                    >
                                      2 Month
                                    </span>
                                    <span
                                      className={`skill-span me-2 ${
                                        activeNoticePeriod === 3 && "active"
                                      }`}
                                      onClick={() => setActiveNoticePeriod(3)}
                                    >
                                      3 Month
                                    </span>
                                    <span
                                      className={`skill-span me-2 ${
                                        activeNoticePeriod === 4 && "active"
                                      }`}
                                      onClick={() => setActiveNoticePeriod(4)}
                                    >
                                      4 Month
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group dflexClm">
                                  <label className="form-label">
                                    Employee Referral Id
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="referral"
                                    className="form-control"
                                    value={referralId}
                                    onChange={(e) =>
                                      setReferralId(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <h3 className="dash-sub-head">
                              Key Skills<sup className="text-danger">*</sup>
                            </h3>
                            <div className="row">
                              <div className="col-md-8">
                                <Select menuPlacement="top"
                                  isMulti
                                  name="colors"
                                  placeholder="Add Skills"
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  options={jobSkills}
                                  value={skillId}
                                  onChange={handleSkillChange}
                                />
                              </div>
                            </div>
                            <div className="d-flex text-end justify-content-end mt-2">
                              <button
                                className=" btn-btn btn btn-btn2 me-2"
                                onClick={Cancel}
                              >
                                Cancel
                              </button>
                              {/* {docLink && ( */}
                                <button
                                  className=" btn-btn btn btn-btn1"
                                  onClick={() => saveForm()}
                                >
                                  {isloading ? (
                                    <img
                                      src={Loading}
                                      alt="loaderImg"
                                      width={20}
                                      height={20}
                                    ></img>
                                  ) : (
                                    "Save"
                                  )}
                                </button>
                              {/* )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
